<template>
  <div :class="['footer', isGameVersion ? 'game_version' : '']">
    <div class="title">关注ToDesk</div>
    <div class="tabs">
      <div
        class="tab_item"
        :class="{ active: active_tab == index }"
        v-for="(item, index) in qrlist"
        :key="index"
        @click="active_tab = index"
      >
        <img
          :src="require(`@/assets/footer/${item.icon}`)"
          alt=""
          class="icon icon0"
        />
        <img
          :src="require(`@/assets/footer/${item.icon_active}`)"
          alt=""
          class="icon icon1"
        />
        <span class="text">{{ item.text }}</span>
      </div>
    </div>
    <div class="qrcode">
      <img :src="require(`@/assets/footer/${qrlist[active_tab].pic}`)" alt="" />
    </div>
    <div class="cr">
      <div class="cr1">
        Copyright © {{ company_name }} 版权所有 <span></span>
      </div>
      <div class="cr1">
        <a
          v-if="ga_num"
          href="https://www.beian.gov.cn/portal/index"
          target="_blank"
          >{{ ga_num }}</a
        >
      </div>
      <div class="cr2">
        增值电信业务经营许可证:
        <a :href="license_link" class="">{{ permit_number }}</a>
        <a href="https://beian.miit.gov.cn/#/Integrated/index">{{
          filingText
        }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active_tab: 0,
      qrlist: [
        {
          icon: "wx@2x.png",
          icon_active: "wx_active@2x.png",
          pic: "wx_qrcode.png",
          text: "微信公众号",
        },
        {
          icon: "wb@2x.png",
          icon_active: "wb_active@2x.png",
          pic: "wb_qrcode.png",
          text: "官方微博",
        },
        {
          icon: "dy@2x.png",
          icon_active: "dy_active@2x.png",
          pic: "dy_qrcode.png",
          text: "官方抖音",
        },
      ],
      // todesk.com
      filingText: "琼ICP备20000605号-1",
      company_name: "海南有趣科技有限公司",
      permit_number: "琼B2-20190526",
      license_link: 'https://beian.miit.gov.cn/#/Integrated/index',
      // license_link: "https://todeskcdnspeed.todesk.com/2024012317530460f99e9ab1d024.png", //许可证图片
      ga_num: "琼公网安备46010802000951号", //网安备案号
    };
  },
  computed: {
    isGameVersion() {
      return this.$route?.name === "gameMb";
    },
  },
  mounted() {
    let _hostname = window.location.hostname;
    if (_hostname.indexOf("todesk.cn") > -1) {
      this.filingText = "琼ICP备20000605号-4";
      this.company_name = "海南有趣科技有限公司";
      this.permit_number = "琼B2-20190526";
      this.license_link = 'https://beian.miit.gov.cn/#/Integrated/index';
      // this.license_link = "https://todeskcdnspeed.todesk.com/2024012317530460f99e9ab1d024.png";
      this.ga_num = "琼公网安备46010802000951号"; //网安备案号
    } else if (_hostname.indexOf("hellodesk.cn") > -1) {
      this.filingText = "沪ICP备2021023161号-1";
      this.company_name = "上海久尺网络科技有限公司";
      this.permit_number = "沪B2-20211712";
      this.license_link = 'https://beian.miit.gov.cn/#/Integrated/index';
      // this.license_link = "https://todeskcdnspeed.todesk.com/202211211231575edf389259e378.png";
      this.ga_num = "沪公网安备31011502018256号"; //网安备案号
    } else if (_hostname.indexOf("izuler.cn") > -1) {
      this.filingText = "沪ICP备2021023161号-2";
      this.company_name = "上海久尺网络科技有限公司";
      this.permit_number = "沪B2-20211712";
      this.license_link = 'https://beian.miit.gov.cn/#/Integrated/index';
      // this.license_link = "https://todeskcdnspeed.todesk.com/202211211231575edf389259e378.png";
      this.ga_num = "沪公网安备31011502018256号"; //网安备案号
    }
  },
};
</script>
<style lang="less" scoped>
.footer {
  background: #272f3c;
  padding-top: 20px;
  padding-bottom: 14px;
  &.game_version {
    background-color: #212121;
  }
  .title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
  }
  .tabs {
    display: flex;
    justify-content: center;
    .tab_item {
      margin-top: 16px;
      margin-left: 4px;
      margin-right: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 106px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 4px;
      border: 1px solid rgba(255, 255, 255, 0.6);
      .icon {
        width: 24px;
        height: 24px;
      }
      .icon0 {
        display: block;
      }
      .icon1 {
        display: none;
      }
      .text {
        margin-left: 8px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
      }
    }
    .tab_item.active {
      background: #0b80fe;
      border-color: #0b80fe;
      .text {
        color: #fff;
      }
      .icon0 {
        display: none;
      }
      .icon1 {
        display: block;
      }
    }
    .tab_item:active {
      background: #1c87fd;
      border-color: #1c87fd;
    }
  }
  .qrcode {
    text-align: center;
    padding-top: 25px;
    padding-bottom: 14px;
    img {
      width: 148px;
      height: 148px;
    }
  }
  .cr {
    padding-top: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    .cr1,
    .cr2 {
      line-height: 14px;
      text-align: center;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.5);
      a {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }
  }
}
</style>
